import { DevicesProcessor } from 'common/repositoryProcessors/index';

(() => {

    /**
     * Body controller
     */
    angular.module('controllers')
        .controller('DashboardBody', ($scope) => {

            const devicesObservable = DevicesProcessor.getObservable();
            const onNextDevice = () => {

                $scope.hasDevices = DevicesProcessor.hasDisplayedDevices();
                $scope.hasMobileDevices = DevicesProcessor.hasAtLeastOnePhoneOrTablet();

            };
            const devicesSubscriber =
                devicesObservable.subscribe(onNextDevice, () => { }, () => { });

            $scope.$on('$destroy', () => {

                devicesSubscriber.dispose();

            });

        });

})();



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/body.js